<div class="card-header-mini">
  <h3 class="card-title">{{widgetData.title}}</h3>
  <a *ngIf="widgetData.allLinkUrl" href="{{widgetData.allLinkUrl}}" target="{{widgetData.allLinkTarget}}" class="more-link">{{widgetData.allLinkText}}</a>
</div>

<div class="carousel-wrap carousel-wrap-with-navigation" *ngIf="!isLoading && news && news.length && !isServerError">
  <swiper-container
    #carousel
    pagination="true"
    pagination-clickable="true"
    [breakpoints]="breakpoints"
    class="carousel"
  >
    <swiper-slide *ngFor="let newsItem of news">
      <app-news-item [data]="newsItem" [openArticleBtnText]="widgetData.btnOpenArticleText" />
    </swiper-slide>
  </swiper-container>

  <div>
    <button *ngIf="news.length > 1" class="button-prev" [ngClass]="{ locked: lockPrev }" (click)="prevSlide()">
      <mat-icon [svgIcon]="'prev-2'" class="square-icon button-icon"></mat-icon>
    </button>
    <button *ngIf="news.length > 1" class="button-next" [ngClass]="{ locked: lockNext }" (click)="nextSlide()">
      <mat-icon [svgIcon]="'next-2'" class="square-icon button-icon"></mat-icon>
    </button>
  </div>
</div>

<div class="carousel-wrap carousel-wrap-with-navigation" *ngIf="isLoading">
  <swiper-container
    #carousel
    pagination="true"
    pagination-clickable="true"
    [breakpoints]="breakpoints"
    class="carousel"
  >
    <swiper-slide>
      <app-news-item [isLoading]="isLoading" [data]="mockNew" [openArticleBtnText]="widgetData.btnOpenArticleText" />
    </swiper-slide>
  </swiper-container>
</div>


<app-timeout-error-message *ngIf="isServerError"></app-timeout-error-message>